<template>
  <ConstrainedContainer>
    <p class="mt-20">
      We're verifying your token
    </p>
  </ConstrainedContainer>
</template>

<script>
import ConstrainedContainer from '@/components/layout-components/containers/constrained-container'
import { $axios } from '../../utils'

export default {
  name: 'SignupInvite',
  components: {
    ConstrainedContainer
  },
  computed: {
    token () {
      return this.$route.params.token
    }
  },
  async mounted () {
    await this.$nextTick()
    try {
      const response = await $axios(`/auth/signup/invite/${this.token}`)
      if (response.status === 200) {
        this.$notify('Successfully verified signup. Please complete signup to continue', {
          type: 'success',
          title: 'Invite verified!'
        })

        const { token } = response.data

        this.$router.push({
          name: 'complete_signup',
          params: {
            token,
            email: this.email
          }
        })
      }
    } catch (error) {
      this.$notify(error.message, {
        type: 'error',
        title: 'Error verifying token',
        duration: 5000
      })
      this.$sentry.captureException(error)
      this.$logger.error(error)
    }
  }
}
</script>
